import { render, staticRenderFns } from "./PackSelector.vue?vue&type=template&id=53321450&"
import script from "./PackSelector.vue?vue&type=script&lang=ts&"
export * from "./PackSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports